/*
 * Full-screen main menu behaviour.
 *
 * Mirrors the storefront overlay: Escape closes, focus starts inside the
 * menu, Tab is trapped so the page behind never receives keyboard focus,
 * the body is locked against scrolling, and focus is restored to whatever
 * opened the menu on close.
 */
(function () {
  var menu = document.getElementById('JoMainMenu');
  if (!menu) return;

  var openers = document.querySelectorAll('[data-jo-menu-open]');
  if (!openers.length) return;

  var lastFocused = null;
  var prevOverflow = '';

  function focusables() {
    return menu.querySelectorAll('a[href], button:not([disabled])');
  }

  function onKeyDown(e) {
    if (e.key === 'Escape') {
      close();
      return;
    }
    if (e.key !== 'Tab') return;

    var items = focusables();
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function open() {
    lastFocused = document.activeElement;
    menu.hidden = false;

    prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeyDown);

    var closeBtn = menu.querySelector('.jo-menu__close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    menu.hidden = true;
    document.body.style.overflow = prevOverflow;
    document.removeEventListener('keydown', onKeyDown);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  Array.prototype.forEach.call(openers, function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
  });

  // Close on the X, and on any link inside — a link navigates away, but on a
  // same-page anchor the overlay would otherwise stay open over the target.
  menu.addEventListener('click', function (e) {
    var hit = e.target.closest ? e.target.closest('[data-jo-menu-close]') : null;
    if (!hit) return;
    if (hit.tagName === 'BUTTON') e.preventDefault();
    close();
  });
})();
